import ConfirmEmployeeForm from './ConfirmEmployeeForm'
import {connect} from 'react-redux'
import {Link} from 'react-router'
import {pageRequest, createEmployeeAccount} from 'actions/confirmEmployee'
import styles from './ConfirmEmployee.css'

class ConfirmEmployee extends React.Component {
  render () {
    let {invalidInvitation, invitedEmployee} = this.props.data.confirmEmployee
    let {business} = invitedEmployee
    return (
      <div className='container'>
        <div className='col-sm-6 col-sm-offset-3'>
          {!invalidInvitation
            ? <div className={styles['form-container']}>
              <h3>Complete Registration</h3>
              <div>
                to accept payment on behalf of <b>{business && business.name}</b>
              </div>
              <ConfirmEmployeeForm onSubmit={this.handleSubmit} />
            </div>
            : <div className={styles['invalid-message']}>
              <h2>Sorry, this invitation is no longer valid.</h2>
            </div>
          }
          <div className={styles['text-signIn']}>
            Already have a Moka account? <Link to='/login'>Sign in.</Link>
          </div>
        </div>
      </div>
    )
  }

  componentDidMount () {
    let {business_id, pending_email} = this.props.location.query
    this.props.dispatch(pageRequest({business_id: business_id, pending_email: pending_email}))
  }

  handleSubmit = (values) => {
    let {business, employee} = this.props.data.confirmEmployee.invitedEmployee
    let inputValues = {
      first_name: values.firstName,
      last_name: values.lastName,
      email: values.email,
      password: values.password,
      password_confirmation: values.confirmPassword
    }
    this.props.dispatch(createEmployeeAccount({business: business, employee: inputValues || employee}))
  }
}

function mapStateToProps (state) {
  return {
    data: {
      confirmEmployee: state.confirmEmployee
    }
  }
}

export default connect(mapStateToProps)(ConfirmEmployee)



// WEBPACK FOOTER //
// ./app/pages/ConfirmEmployee/ConfirmEmployee.js